export const PDFConstants = {
  amountX: 100,
  totalAmountX: 140,
  schX: 180,
  maxUnderlineWidth: 30,
  maxSchUnderlineWidth: 25,
  lineHeight: 6,
  pageHeight: null,
  initY: 60,
};

export const PDFLandscapeScheduleConstants = {
  amountX: 100,
  totalAmountX: 140,
  leftX: 12,
  rightX: 250,
  schX: 250,
  maxUnderlineWidth: 30,
  maxSchUnderlineWidth: 25,
  lineHeight: 6,
  pageHeight: null,
  initY: 20,
};

export const PDFPortraitScheduleConstants = {
  amountX: 75,
  totalAmountX: 140,
  leftX: 15,
  rightX: 170,
  maxUnderlineWidth: 30,
  maxSchUnderlineWidth: 25,
  lineHeight: 6,
  pageHeight: null,
  initY: 20,
};
